import { classNames } from "../../helpers";

export default function LogoutIcon(props) {
  const { imageClassName } = props

  return (
    <svg className={classNames("text-secondary ", props.className)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Iconly/Light/Logout">
        <g id="Logout">
          <path id="Stroke 1" d="M15.016 7.38948V6.45648C15.016 4.42148 13.366 2.77148 11.331 2.77148H6.45597C4.42197 2.77148 2.77197 4.42148 2.77197 6.45648V17.5865C2.77197 19.6215 4.42197 21.2715 6.45597 21.2715H11.341C13.37 21.2715 15.016 19.6265 15.016 17.5975V16.6545" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path id="Stroke 3" d="M21.8096 12.0214H9.76855" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path id="Stroke 5" d="M18.8811 9.10632L21.8091 12.0213L18.8811 14.9373" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
    </svg>
  );
}
